export default "__VITE_ASSET__de868b31__"